<template>
  <KTCodePreview v-bind:title="'Duyệt phiếu chuyển kho'">
    <template v-slot:preview>
      <StockSlipSkeleton
        :renderComponent="renderComponent"
        v-if="!renderComponent"
      />
      <div v-if="renderComponent">
        <b-row class="mb-5 col-12" v-if="stockSlip.code">
          <label class="font-weight-bold"
            >Mã phiếu kho:
            <a class="text-primary">{{ stockSlip.code }}</a></label
          >
        </b-row>
        <b-row class="mb-5 col-6">
          <StockSlipTransfer
            :stockSlip="stockSlip"
            :stores="filteredOptions"
            @onSelectedSourceWarehouse="onSelectedSourceWarehouse"
            @onInputChangeSourceWarehouse="onInputChangeSourceWarehouse"
            @onSelectedDestinationWarehouse="onSelectedDestinationWarehouse"
            @onInputChangeDestinationWarehouse="
              onInputChangeDestinationWarehouse
            "
            :editable="false"
          />
        </b-row>
        <b-row class="mb-5">
          <ApprovalTransferProduct
            :editable="true"
            :productItems="stockSlip.details"
            :action="'approve'"
            :storeId="stockSlip.sourceWarehouseId"
          />
        </b-row>
      </div>
    </template>
    <template v-slot:foot>
      <b-button
        style="font-weight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        >Duyệt</b-button
      >
      <router-link to="/employees" tag="button">
        <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        >
      </router-link>
    </template>
  </KTCodePreview>
</template>

<script>
import ApiService from '@/core/services/api.service';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { makeToastFaile, makeToastSuccess, xoa_dau } from '@/utils/common';
import StockSlipSkeleton from '../../../components/stock-slips/StockSlipSkeleton.vue';
import StockSlipTransfer from '../../../components/stock-slips/StockSlipTransfer.vue';
import ApprovalTransferProduct from '../../../components/stock-slips/ApprovalTransferProduct.vue';

export default {
  data() {
    return {
      stockSlip: {
        id: null,
        code: '',
        type: 3,
        status: 1,
        sourceWarehouseName: '',
        sourceWarehouseId: null,
        destinationWarehouseName: '',
        destinationWarehouseId: null,
        notes: '',
        details: [],
      },
      filteredOptions: [],
      stores: [],
      isSubmitting: false,
      renderComponent: true,
    };
  },
  components: {
    KTCodePreview,
    StockSlipSkeleton,
    StockSlipTransfer,
    ApprovalTransferProduct,
  },
  async created() {
    await this.fetchStore();
    this.stockSlip.id = this.$route.query?.id || null;
    if (this.stockSlip.id) {
      await this.getStockSlipByID();
    }
  },
  methods: {
    fetchStore: async function () {
      this.filteredOptions = [];
      ApiService.get('v1/stores/all').then((response) => {
        this.stores = response.data.data;
        this.filteredOptions = [...this.stores];
      });
    },
    approveStockSlip: async function () {
      const details = this.stockSlip.details.map((element) => {
        let quantityApprove = element.quantityApprove || 0;
        const imeis = element.IMEI?.trim() || '';
        if(element.productType === 2) {
        const imeiList = imeis.split(',').map((imei) => imei.trim());
        quantityApprove = imeiList.length
          ? imeiList.length
          : element.quantityApprove;
        }
        return {
          id: element.id,
          productId: element.productId,
          imeis,
          quantity: element.quantity,
          quantityApprove: quantityApprove,
          quantityConfirm: element.quantityConfirm || 0,
        };
      });
      const zeroQuantityItems = details.filter(
        (detail) => !detail.quantityApprove,
      );
      if (zeroQuantityItems.length === details.length) {
        this.isSubmitting = false;
        return makeToastFaile('Vui lòng nhập số lượng duyệt cho sản phẩm!');
      }
      const payload = {
        id: this.stockSlip.id,
        details,
      };

      try {
        const res = await ApiService.put(
          'v1/transfer-stock-slips/approve',
          payload,
        ).catch((error) => {
          this.isSubmitting = false;
          const message = error?.response?.data?.message || 'Lỗi!';
          makeToastFaile(message);
        });
        makeToastSuccess(res.data.message);
        this.$router.push({
          name: 'list-inventory-transfer',
        });
      } catch ({ response }) {
        makeToastFaile(response.$error);
      } finally {
        this.isSubmitting = false;
      }
    },
    onSubmit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.approveStockSlip();
    },
    onSelectedSourceWarehouse(option) {
      this.stockSlip.sourceWarehouseName = option.item.name;
      this.stockSlip.sourceWarehouseId = option.item.id;
    },
    onInputChangeSourceWarehouse(text) {
      this.stockSlip.sourceWarehouseName = text;
      const filteredData = this.stores
        .filter((item) => {
          return (
            xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
      this.filteredOptions = [...filteredData];
    },
    onSelectedDestinationWarehouse(option) {
      this.stockSlip.destinationWarehouseName = option.item.name;
      this.stockSlip.destinationWarehouseId = option.item.id;
    },
    onInputChangeDestinationWarehouse(text) {
      this.stockSlip.destinationWarehouseName = text;
      const filteredData = this.stores
        .filter((item) => {
          return (
            xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
      this.filteredOptions = [...filteredData];
    },
    getStockSlipByID: async function () {
      this.renderComponent = false;
      ApiService.get(`v1/transfer-stock-slips/${this.stockSlip.id}`).then(
        (data) => {
          const stockSlipData = data.data.data;
          this.stockSlip.code = stockSlipData.code;
          this.stockSlip.type = stockSlipData.type;
          this.stockSlip.status = stockSlipData.status;
          this.stockSlip.sourceWarehouseId = stockSlipData.sourceWarehouseId;
          this.stockSlip.sourceWarehouseName =
            stockSlipData.sourceWarehouseName;
          this.stockSlip.destinationWarehouseId =
            stockSlipData.destinationWarehouseId;
          this.stockSlip.destinationWarehouseName =
            stockSlipData.destinationWarehouseName;
          this.stockSlip.notes = stockSlipData.description;
          this.stockSlip.details = stockSlipData.details.map(
            (detail, index) => {
              return {
                ...detail,
                stt: index + 1,
                productPriceMask: detail.unitPrice,
                IMEI: detail.productImei || '',
                quantityApprove:
                  detail.quantityApprove || detail.approveQuantity,
              };
            },
          );
          this.renderComponent = true;
        },
      );
    },
  },
};
</script>
